import { useQuery } from '@tanstack/react-query'
import * as homeApi from '../home.api'
import type { HomeData } from '../types/home.types'

export function useHomeData() {
  return useQuery<HomeData>({
    queryKey: ['home', 'dashboard'],
    queryFn: homeApi.getHomeData,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  })
}
